import { SectionDivider } from "./section-divider";
import { FileUploadInput } from "@/components/ui/file-upload-input";
import { SettingsFooterActions } from "./settings-footer-actions";

interface DocumentosTabProps {
  documents: {
    contratoSocial: File | null;
    comprovanteEnderecoPJ: File | null;
    cartaoCNPJ: File | null;
    comprovanteContaBancariaPJ: File | null;
    documentoFotoRGCNH: File | null;
    comprovanteEnderecoPF: File | null;
    drtOuSimilar: File | null;
    carteiraVacinacao: File | null;
  };
  onDocumentChange: (field: string, file: File | null) => void;
  onSave: () => void;
  onCancel: () => void;
  isSaving?: boolean;
}

export function DocumentosTab({ documents, onDocumentChange, onSave, onCancel, isSaving }: DocumentosTabProps) {
  return (
    <div className="flex flex-col gap-4 w-full">
      <div className="bg-[#15203c] rounded-lg p-4 flex flex-col gap-5">
        {/* Section Title */}
        <div className="flex flex-col gap-0.5">
          <h2 className="font-['Plus_Jakarta_Sans'] font-bold text-xl text-white leading-normal">
            Documentos anexos - Pessoa Física e Pessoa Jurídica
          </h2>
          <p className="font-['Plus_Jakarta_Sans'] font-normal text-xs text-[#d1d1d1] leading-normal">
            Atualize seus dados como PJ
          </p>
        </div>

        <div className="flex flex-col gap-3">
          {/* INFORMAÇÕES DA EMPRESA Section */}
          <SectionDivider title="informações da empresa" />

          {/* Row 1: Contrato Social (full-width) */}
          <FileUploadInput
            label="Contrato social da empresa contratada (é imprescindível que o nome do profissional contratado conste no contrato social)."
            value={documents.contratoSocial}
            onChange={(file) => onDocumentChange('contratoSocial', file)}
          />

          {/* Row 2: Comprovante Endereço PJ | Cartão CNPJ */}
          <div className="flex gap-4">
            <FileUploadInput
              label="Comprovante de endereço (PJ)"
              value={documents.comprovanteEnderecoPJ}
              onChange={(file) => onDocumentChange('comprovanteEnderecoPJ', file)}
              className="flex-1"
            />
            <FileUploadInput
              label="Cartão de CNPJ (com a data do mês atual e dados atualizados)"
              value={documents.cartaoCNPJ}
              onChange={(file) => onDocumentChange('cartaoCNPJ', file)}
              className="flex-1"
            />
          </div>

          {/* Row 3: Comprovante Conta Bancária PJ | Documento com Foto */}
          <div className="flex gap-4">
            <FileUploadInput
              label="Comprovante de conta bancária (PJ)"
              value={documents.comprovanteContaBancariaPJ}
              onChange={(file) => onDocumentChange('comprovanteContaBancariaPJ', file)}
              className="flex-1"
            />
            <FileUploadInput
              label="Documento com foto (RG/CNH) do representante legal / profissional contratado"
              value={documents.documentoFotoRGCNH}
              onChange={(file) => onDocumentChange('documentoFotoRGCNH', file)}
              className="flex-1"
            />
          </div>

          {/* Row 4: Comprovante Endereço PF | DRT ou Similar */}
          <div className="flex gap-4">
            <FileUploadInput
              label="Comprovante de endereço (PF)"
              value={documents.comprovanteEnderecoPF}
              onChange={(file) => onDocumentChange('comprovanteEnderecoPF', file)}
              className="flex-1"
            />
            <FileUploadInput
              label="DRT ou similar"
              value={documents.drtOuSimilar}
              onChange={(file) => onDocumentChange('drtOuSimilar', file)}
              className="flex-1"
            />
          </div>

          {/* Row 5: Carteira Vacinação (full-width) */}
          <FileUploadInput
            label="Carteira de Vacinação Covid-19"
            value={documents.carteiraVacinacao}
            onChange={(file) => onDocumentChange('carteiraVacinacao', file)}
          />
        </div>
      </div>
      <SettingsFooterActions onSave={onSave} onCancel={onCancel} isSaving={isSaving} />
    </div>
  );
}
